const navLinks = document.querySelectorAll(".navigation-link a.btn");
let activeLink = null;
let leaveTimer = null;
let activePanel = null;

function cancelLeaveTimer() {
    if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
    }
}

function scheduleClose(navDiv) {
    cancelLeaveTimer();
    leaveTimer = setTimeout(() => {
        navDiv.classList.remove('active');
        if (activePanel === navDiv) {
            activePanel = null;
        }
    }, 500);
}

navLinks.forEach(link => {
    const id = link.getAttribute("data-nav");
    const panel = document.querySelector(`[data-panel="${id}"]`);

    link.addEventListener('mouseover', () => {
        cancelLeaveTimer();

        link.classList.add('active');
        if (!panel) {
            if (activePanel) {
                activePanel.classList.remove('active');
                activePanel = null;
            }
            return;
        }

        if (activePanel && activePanel !== panel) {
            activePanel.classList.remove('active');
        }

        panel.classList.add('active');
        activePanel = panel;
    });

    link.addEventListener('mouseout', () => {

        if (!panel) {
            link.classList.remove('active');
            return;
        }
        scheduleClose(panel);
    });

    if (panel) {
        panel.addEventListener('mouseenter', cancelLeaveTimer);

        panel.addEventListener('mouseleave', () => {
            scheduleClose(panel);
        });
    }
});

const coursePanelLinks = document.querySelectorAll('.course-category-item');
let activeCoursePanelLink = coursePanelLinks[0];
const courseCategoryContents = document.querySelectorAll('.courses-panel-content');
let activeCourseCategoryContent = courseCategoryContents[0];

coursePanelLinks.forEach(link => {
    link.addEventListener('mouseover', () => {
        activeCoursePanelLink.classList.remove('active');
        activeCoursePanelLink = link;
        activeCoursePanelLink.classList.add('active');

        const categoryId = link.getAttribute("data-category");
        const courseCategoryContent = document.querySelector(`.courses-panel-content[data-category="${categoryId}"]`);
        courseCategoryContents.forEach(courseCategory => {
            courseCategory.classList.remove('active');
        });

        activeCourseCategoryContent = courseCategoryContent;
        if (activeCourseCategoryContent) {
            activeCourseCategoryContent.classList.add('active');
        }
    });
})

const rolePanelLinks = document.querySelectorAll('.role-categories-item');
let activeRolePanelLink = rolePanelLinks[0];
const roleContents = document.querySelectorAll('.role-panel-content');
let activeRoleContent = roleContents[0];

rolePanelLinks.forEach(link => {
    link.addEventListener('mouseover', () => {
        activeRolePanelLink.classList.remove('active');
        activeRolePanelLink = link;
        activeRolePanelLink.classList.add('active');

        const roleId = link.getAttribute("data-role");
        const roleContent = document.querySelector(`.role-panel-content[data-role="${roleId}"]`);
        roleContents.forEach(content => {
            content.classList.remove('active');
        });

        activeRoleContent = roleContent;
        if (activeRoleContent) {
            activeRoleContent.classList.add('active');
        }
    });
})